import Visita from "./visita/index"

export default {
    Visita
}